module.exports = __webpack_public_path__ + "00fda61dfe7f2460be81d4b574e756.svg";